<!-- 有组别/无组别抽签签到 -->
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛程</el-breadcrumb-item>
      <el-breadcrumb-item>全国总决选</el-breadcrumb-item>
      <el-breadcrumb-item>{{queryForm.isGroup === 1 ? '有组别' : '无组别'}}上场顺序抽签</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <div class="page-title" v-if="queryForm.isGroup === 1">{{ levelStr }}-上场顺序抽签</div>
    <div class="page-title" v-if="queryForm.isGroup === 2">无组别-上场顺序抽签</div>
    <div class="page-title">
      总人数：<span>{{total}}</span>
      已抽签：<span>{{signNum}}</span>
      未抽签：<span>{{notSignNum}}</span>
    </div>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="6" v-if="this.queryForm.isGroup === 1">
            <el-form-item label="组别" prop="level">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.level"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="抽签状态" prop="isRace">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.isRace"
              >
                <el-option label="未抽签" :value="0"></el-option>
                <el-option label="已抽签" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            @click="search"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button plain type="primary" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">选手列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="setMatchNum">一键生成抽签号码</el-button>
        </el-col>
      </el-row>
        <el-table
          header-cell-class-name="tableHeaderStyle"
          :data="dataList"
          border
          stripe
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="赛季" prop="season"></el-table-column>
          <el-table-column label="姓名" prop="userName"></el-table-column>
          <el-table-column label="学校" prop="schoolName"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
          <el-table-column
            label="组别"
            prop="enrollmentLevel"
            :formatter="levelFormatter"
          ></el-table-column>
          <el-table-column
            label="年级"
            prop="grade"
            :formatter="gradeFormatter"
          ></el-table-column>
          <el-table-column label="比赛号码牌" prop="matchNum">
            <template slot-scope="scope">
              <span class="num num1">{{ addZero(scope.row.matchNum) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="抽签状态" prop="isRace">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isRace ? 'success' : 'danger'" size="mini">{{scope.row.isRace ? '已抽签' : '未抽签'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="抽签号码" prop="raceNumber">
            <template slot-scope="scope">
              <span class="num">{{ addZero(scope.row.raceNumber) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="editFn(scope.row)"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
    </el-card>
    <el-dialog
      title="修改抽签状态"
      :visible.sync="dialogVisible"
      @close="dialogVisible = false"
      width="600px"
    >
      <div class="row">
        <div class="col" v-for="(value, key) in editInfo" :key="key">
          <div class="label">{{ key }}：</div>
          <div class="value">{{ value }}</div>
        </div>
        <div class="col">
          <div class="label">比赛号码牌：</div>
          <div class="value value-num">{{ addZero(matchNum) }}</div>
        </div>
        <div class="col">
          <div class="label">签到状态：</div>
          <div class="value">
            <el-tag :type="signReport ? 'success' : 'danger'" size="mini">{{signReport ? '已签到' : '未签到'}}</el-tag>
          </div>
        </div>
        <div class="col">
          <div class="label">物料领取：</div>
          <div class="value">
            <el-tag :type="signMateriel ? 'success' : 'warning'" size="mini">{{signMateriel ? '已领取' : '未领取'}}</el-tag>
          </div>
        </div>
        <div class="col">
          <div class="label">抽签号码：</div>
          <div class="value">
            <el-input-number v-model="raceNumber" @change="handleChange"></el-input-number>
          </div>
        </div>
        <div class="col">
          <div class="label">抽签状态：</div>
          <div class="value">
            <el-switch v-model="isRace"></el-switch>
            {{ isRace ? '已抽签' : '未抽签' }}
          </div>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="submit">保存修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_grade: this.$userInfo.getGradeData(),
      dict_group: this.$userInfo.dict_group(),
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: this.$chnEngStatusCode.raceScheduleFinal,
        phone: '',
        userName: '',
        isRace: '',
        level: Number(this.$route.query.g) === 1 ? 1 : '',
        isGroup: 1
      },
      dataList: [],
      dialogVisible: false,
      editInfo: {},
      raceNumber: '',
      isRace: false,
      matchNum: '',
      signReport: '',
      signMateriel: '',
      levelStr: '',
      total: 0,
      signNum: 0,
      notSignNum: 0
    }
  },
  created () {
    this.queryForm.isGroup = Number(this.$route.query.g)
    if (this.queryForm.isGroup === 1) {
      this.getLevelStr()
    }
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getLevelStr () {
      this.levelStr = this.dict_group.find(item => item.dictCode === this.queryForm.level).dictLabel
    },
    getList () {
      this.$http.get('/national/queryNationalGroupList', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.dataList = res.data
          this.total = res.data.length
          this.signNum = res.data.filter(item => item.isRace === 1).length
          this.notSignNum = this.total - this.signNum
        }
      })
    },
    // 生成抽签号码
    setMatchNum () {
      const haveDone = this.dataList.filter(item => item.raceNumber)
      if (haveDone.length) {
        this.$confirm('抽签号码已生成，请慎重操作。是否重新生成?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doneFn()
        }).catch(() => {
        })
      } else {
        this.doneFn()
      }
    },
    doneFn () {
      const params = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        isGroup: this.queryForm.isGroup
      }
      if (this.queryForm.isGroup === 1) {
        params.level = this.queryForm.level
      }
      this.$http.get('/national/drawLotsForDifferentGroups', { params }).then(res => {
        if (res.code === 200) {
          this.getList()
          this.$message.success('已生成')
        }
      })
    },
    // 修改状态
    editFn (item) {
      const obj = {}
      obj['姓名'] = item.userName
      obj['手机号'] = item.phone
      obj['学校'] = item.schoolName
      obj['年级'] = this.gradeFormatter(item)
      obj['组别'] = this.levelFormatter(item)

      this.editInfo = obj
      this.id = item.id
      this.signMateriel = item.signMateriel
      this.signReport = item.signReport
      this.matchNum = item.matchNum
      this.raceNumber = item.raceNumber
      this.isRace = item.isRace === 1
      this.dialogVisible = true
    },
    search () {
      this.queryForm.pageNum = 1
      if (this.queryForm.isGroup === 1) {
        this.getLevelStr()
      }
      this.getList()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    gradeFormatter (data) {
      return data.grade ? this.dict_grade.find(item => item.dictCode === data.grade).dictLabel : '--'
    },
    levelFormatter (data) {
      return data.level ? this.dict_group.find(item => item.dictCode === data.level).dictLabel : '--'
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    submit () {
      this.$http.post('/national/updateDifferentGroups', {
        id: this.id,
        isRace: this.isRace ? 1 : 0,
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        raceNumber: String(this.raceNumber),
        isGroup: this.queryForm.isGroup

      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.getList()
        }
      })
    },
    handleChange () {

    }
  }
}
</script>
<style lang="less" scoped>
.page-title{
  font-size: 18px;
  color: #000;
  margin-bottom: 10px;
  text-align: center;
  span {
    margin-right: 20px;
    color: #409EFF;
    font-size: 20px;
  }
}
.num {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}
.num1{
  color: #000;
}
.col{
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.label{
  width: 120px;
  text-align: right;
}
.value-num{
  font-size: 26px;
  font-weight: bold;
  color: #000;
}
.btn{
  text-align: center;
}
</style>
